import styled from 'styled-components'
import { theme, VerticalSpacer, Body } from '@superhi/design'

type WrapperProps = {
  $isLoading: boolean
}

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  align-items: flex-start;
  opacity: ${({ $isLoading }) => ($isLoading ? 0.5 : 1)};
  pointer-events: ${({ $isLoading }) => ($isLoading ? 'none' : 'auto')};

  > *:nth-child(2) {
    flex-grow: 1;
  }

  > *:not(:nth-child(2)) {
    flex-shrink: 0;
  }

  > *:not(:last-child) {
    margin-right: 16px;

    @media ${theme.breakpoints.medium} {
      margin-right: 16px;
    }

    @media ${theme.breakpoints.large} {
      margin-right: 24px;
    }
  }
`

export const Content = styled(VerticalSpacer).attrs({
  amount: { small: 8, medium: 8, large: 8 },
})`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`

export const Options = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;

  > *:not(:last-child) {
    margin-right: 16px;
  }
`

export const Info = styled(Body).attrs({ inline: true, color: 'GREY_70', level: '3' })``

export const Price = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: flex-end;
  flex-direction: column;

  > *:not(:last-child) {
    margin-bottom: 4px;
  }

  && {
    flex-shrink: 1;
  }
`

export const ImageWrapper = styled.div`
  flex-shrink: 0;
  width: 20%;
`
